import React, { Component } from 'react'

import { assetUrl } from '../../../config';
import AutoVideo from '../../AutoVideo';
import $ from 'jquery';
import { withT } from '../../../i18n';
class DownTheRabbitHole extends Component {
    server_path = window.src_path;
    constructor() {
        super()
    }

    loadInitJs() {
        /* var item_name = this.pr */
        /* console.log(item_name); */
    }
    componentDidMount() {
        this.loadInitJs();
    }
    render() {
        const { t } = this.props;
        return (
            <>
                <div className="portfolio__main">
                    <div className="wrapper">
                        <div className="portfolio__inner">
                            <div className="left__panel">
                                <div className="image_div">
                                    <AutoVideo controls src={assetUrl('collection/topslide/Down-the-Rabbit-Hole.mp4')} poster={assetUrl('collection/topslide/Down-the-Rabbit-Hole.jpg')} aria-label="Down the Rabbit Hole"></AutoVideo>
                                </div>
                            </div>
                            <div className="right__panel">
                                <h2 className="heading">Down the Rabbit Hole</h2>

                                <h2 className="artist_name"><span>{t('work.by')} </span> Andreas Wannerstedt </h2>
                                <div className="desc">
                                    <p>Music & sound design by un.studios. First artwork from my 'Eternal Installations' collection, a surreal journey through a series of dreamlike environments, where large-scale art installations are stretching the boundaries of physical laws.</p>
                                </div>

                                <a href="https://opensea.io/assets/0xb932a70a57673d89f4acffbe830e8ed7f75fb9e0/21853" className="css_btn"><span>{t('work.viewArtwork')}</span></a>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default withT(DownTheRabbitHole);
